// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"63":"d4cb21c757339a49","390":"a369aa1305ad7a66"}[chunkId] + ".js";
};